// components
import maInputSelect from '@/components/input/modules/select'

// api
import {
  apiGetAdminDamagesWarrantyTypes,
  apiGetAdminDamagesWarrantySubtypes
} from '@/services/API/admin'

/**
 * @module
 * @name Filters
 */
export default {
  name: 'Filters',
  /**
   * @property {Object} filter Filters object.
   * @property {String} filter.warranty Warranty id filter.
   * @property {String} filter.subwarranty Subwarranty id filter.
   * @property {Array} warrantyTypes Array of tuples key, value defining
   *  warranty types.
   * @property {Array} subwarrantyTypes Array of tuples key, value defining
   * subwarranty types.
   */
  data: function () {
    return {
      filter: {
        warranty: null,
        subwarranty: null
      },
      warrantyTypes: [],
      subwarrantyTypes: []
    }
  },
  components: {
    maInputSelect
  },
  methods: {
    /**
     * @function
     * @name setWarrantyTypesFilter
     * @description Get warranty types from backend.
     */
    setWarrantyTypesFilter: function () {
      apiGetAdminDamagesWarrantyTypes()
        .then(types => {
          if (types && types.length > 0) {
            this.warrantyTypes = types
          }
        })
    },

    /**
     * @function
     * @name setWarrantySubtypesFilter
     * @description Get subwarranty types from backend.
     */
    setWarrantySubtypesFilter: function () {
      const that = this
      apiGetAdminDamagesWarrantySubtypes(this.filter.warranty)
        .then(subtypes => {
          if (subtypes && subtypes.length > 0) {
            that.subwarrantyTypes = subtypes
          }
        })
    },

    /**
     * @function
     * @name handleFilterChange
     * @param {String} event Filter warranty id.
     * @description Set local state filter, update subwarranty types and emit
     *  an event that will be caught to update table data.
     */
    handleFilterChange: function (event) {
      if (event) {
        this.filter.warranty = event
        this.filter.subwarranty = null
        this.subwarrantyTypes = []

        this.$emit('filter:change', this.filter)
        this.setWarrantySubtypesFilter()
      } else {
        this.filter.subwarranty = null
        this.filter.warranty = null
        this.subwarrantyTypes = []
        this.warrantyTypes = []

        this.$emit('filter:change', this.filter)
      }
    },

    /**
     * @function
     * @name handleSubfilterChange
     * @param {String} event Filter subwarranty id.
     * @description Set local state subfilter to handler event. Emit an event to be
     *  caught in order to update table data.
     */
    handleSubfilterChange: function (event) {
      if (event) {
        this.filter.subwarranty = event
        this.$emit('filter:change', this.filter)
      } else {
        this.filter.subwarranty = null
        this.$emit('filter:change', this.filter)
      }
    }
  },

  /**
   * @function
   * @name mounted
   * @description Init warranty types.
   */
  beforeMount: function () {
    this.setWarrantyTypesFilter()
  }
}
